import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type FetchCitizenshipsOperation = paths['/executor_web/citizenships']['get'];

export type FetchCitizenshipsQuery = NonNullable<FetchCitizenshipsOperation['parameters']['query']>;
export type FetchCitizenshipsResponse =
	FetchCitizenshipsOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/citizenships` — см. `paths['/executor_web/citizenships']` в auth swagger */
export function fetchCitizenships(query?: FetchCitizenshipsQuery, signal?: AbortSignal) {
	return axiosInstance.get<FetchCitizenshipsResponse>('citizenships', {params: query, signal});
}
